export default __webpack_public_path__ + "static/karen-94af55068702f23eac9418e4dacb0453.png";